<!-- Mover el topbar FUERA del contenedor animado para que position:fixed no herede transform -->
<app-topbar></app-topbar>

<!-- Espaciador para safe-area en mobile debajo del topbar -->
<div class="safe-spacer lg:hidden" style="margin-top: 0; padding-top: 0; height: var(--topbar-offset, calc(env(safe-area-inset-top, 0px) + 64px));"></div>

<!-- Nuevo sidebar solo mobile (fuera de contenedor animado para no heredar transforms) -->
<app-mobile-sidebar></app-mobile-sidebar>
<app-ayuda-shortcut />

<div appFadeSlideInOnce="dashboard">
    <div class="layout-wrapper" [ngClass]="containerClass">
        <!-- 🔹 Sidebar viejo -->
        <!-- <app-sidebar></app-sidebar> -->

    <!-- 🔹 Nuevo sidebar solo mobile (movido arriba) -->

        <div class="layout-main-container">
            <div class="layout-main">
                <div class="container">
                    <router-outlet></router-outlet>
                </div>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
</div>

<p-scrollTop target="window" [threshold]="130" icon="pi pi-arrow-up" class="fab-scrolltop md:hidden" [buttonProps]="{ severity: 'secondary', raised: true, rounded: true }" />
